module.exports = __webpack_public_path__ + "static/media/ComicSansMS.9bd01fef.woff2";